import MinhasCobrancas from './components/MinhasCobrancas'
import Demonstrativo from './components/Demonstrativo'

export default [
  {
    path: '/financeiro/minhas-cobrancas',
    component: MinhasCobrancas,
    name: 'financeiro.minhas-cobrancas',
    meta: {
      breadcrumb: {
        name: 'Minhas Cobranças'
      }
    }
  },
  {
    path: '/financeiro/demonstrativo',
    component: Demonstrativo,
    name: 'financeiro.demonstrativo',
    meta: {
      breadcrumb: {
        name: 'Demonstrativo Financeiro'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/app/domains/financeiro/routes.js